import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import SectionHeading from "@/components/SectionHeading";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)).catch(() => {}); }, []);

  const categories = ["All", ...Array.from(new Set(products.map((p) => p.category)))];
  const visible = filter === "All" ? products : products.filter((p) => p.category === filter);

  return (
    <div data-testid="shop-page" className="pt-32 pb-24 px-6 md:px-10">
      <div className="mx-auto max-w-[1400px]">
        <SectionHeading
          eyebrow="The Apothecary"
          title="Grooming, fit for the throne."
          subtitle="Hand-picked products our barbers actually use. Available in-shop. Online checkout coming soon."
          testIdBase="shop-header"
        />

        <div className="flex flex-wrap gap-3 mb-10 mt-12">
          {categories.map((c) => (
            <button
              key={c}
              data-testid={`shop-filter-${c.toLowerCase()}`}
              onClick={() => setFilter(c)}
              className={`text-xs uppercase tracking-[0.22em] px-4 py-2.5 border transition-colors ${
                filter === c
                  ? "bg-monarch-gold text-monarch-black border-monarch-gold"
                  : "border-monarch-gold/30 text-monarch-cream/80 hover:border-monarch-gold hover:text-monarch-gold"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {visible.map((p) => (
            <article key={p.id} data-testid={`product-card-${p.id}`} className="card-monarch group overflow-hidden">
              <div className="img-zoom aspect-[4/5] bg-monarch-coal">
                <img src={p.image} alt={p.name} className="w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <div className="text-[10px] uppercase tracking-[0.3em] text-monarch-gold mb-2">{p.category}</div>
                <div className="flex items-baseline justify-between gap-3 mb-3">
                  <h3 className="font-serif text-xl text-monarch-cream">{p.name}</h3>
                  <span className="text-monarch-gold font-serif text-lg">${p.price}</span>
                </div>
                <p className="text-sm text-monarch-ash leading-relaxed">{p.description}</p>
                <div className="mt-5 pt-4 border-t border-monarch-gold/15 text-[11px] tracking-[0.22em] uppercase text-monarch-ash">
                  Available in-shop
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
